<template>
    <header class="bg-[#1a1a1a] text-white shadow sticky top-0 z-50">
        <div class="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">

            <!-- LOGO -->
            <router-link to="/home" class="flex items-center gap-2 cursor-pointer">
                <img src="/logo.png" alt="Logo" class="h-10 w-auto" />
                <span class="font-bold text-lg">GetLance</span>
            </router-link>

            <!-- NAV DESKTOP -->
            <nav class="hidden md:flex items-center gap-8">
                <router-link to="/projetos" class="hover:text-[#b99a52] transition">Projetos</router-link>
                <router-link to="/meus-projetos" class="hover:text-[#b99a52] transition">Meus Projetos</router-link>
                <router-link to="/minhas-propostas" class="hover:text-[#b99a52] transition">Minhas Propostas</router-link>
                <router-link to="/favoritos" class="hover:text-[#b99a52] transition">Favoritos</router-link>
                <router-link to="/perfil" class="hover:text-[#b99a52] transition">Meu Perfil</router-link>
            </nav>

            <!-- AÇÕES -->
            <div class="flex items-center gap-4">

                <!-- BOTÃO DESTAQUE (CRIAR PROJETO) -->
                <router-link
                    to="/cadastre-seu-projeto"
                    class="hidden md:inline-block bg-[#b99a52] hover:bg-[#a18446] px-4 py-2 rounded-full font-semibold shadow transition">
                    Criar Projeto
                </router-link>

                <!-- SAIR -->
                <button
                    @click="handleLogout"
                    class="px-4 py-2 rounded-full border border-white/20 bg-white/10 hover:bg-white/20 transition">
                    Sair
                </button>

                <!-- MENU MOBILE (FILTROS) -->
                <button
                    class="md:hidden text-2xl"
                    @click="$emit('open-filters')">
                    ☰
                </button>

            </div>
        </div>
    </header>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    name: "Header",
    methods: {
        ...mapActions(['logout']), 

        handleLogout() {
            this.logout();

            if (this.$route.path !== '/') {
                this.$router.push('/');
            }
        }
    }
};
</script>
